import React, { useContext } from 'react';
import HeaderBanner from '../HeaderBanner';

import { AppContext } from '../../../providers/AppContext';

const PPPBanner = () => {
  const { ppp = {} } = useContext(AppContext);
  const { showBanner = false } = ppp;
  if (!showBanner) return null;

  return (
    <HeaderBanner bannerId="pppApplication" className="pppApplication">
      Looking for PPP funding? Apply for your first or second PPP loan{' '}
      <a href="/ppp">here.</a>
    </HeaderBanner>
  );
};

export default PPPBanner;
